export const validateBankOfferTransformer = (offerList: ValidateBankOfferList) => {
    return {
      eligibleOffers: offerList.eligibleOffers,
    };
};